const menu = {
    label: 'Vitrine',
    icon: 'pi pi-images',
    to: '/sol/vitrine',
    rules: ['SOL-000'],
};

export default menu;
